import React from "react";
import { IPetsyTableGreenBoxesProps } from "./PetsyTableGreenBoxes.types";
import {
  useFlowData,
  Icon,
  IconSize,
  IconColorStyle
} from "@adaptis/flow-components";
import _ from "../../imports/lodash-imports";
import "./PetsyTableGreenBoxes.scss";

export default function PetsyTableGreenBoxes(props: IPetsyTableGreenBoxesProps) {
  const { getData } = useFlowData();
  const [isPet3Age, setIsPet3Age] = React.useState<boolean>(true);

  React.useEffect(() => {
    const petAgeOnStartDatePolicy = getData("petAgeOnStartDatePolicy");
    // 1094 = 2years + 364 days (1 year = 365 days)
    console.log("props.isCheckPetAge", props.isCheckPetAge, petAgeOnStartDatePolicy);
    if (props.isCheckPetAge && petAgeOnStartDatePolicy > 1094) {
      setIsPet3Age(false);
      console.log("IS 3 YEAR PET");
    }
  }, []);

  return (
    <div className={`flc_petsy_table_green_boxes ${props.className ? props.className : ""}`}>
      <div className="table-header">
        <div className="title">{props.title}</div>
        {props.subTitle && <div className="sub-title">{props.subTitle}</div>}
      </div>
      <div className="table-content">
        <table className="table table-boxes">
          <tbody>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Emergency vet visits</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Cancer treatment and chemotherapy</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Treatment by veterinary specialists</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Diabetes</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Hospitalisation</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Hip and elbow dysplasia</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Surgeries</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Ingestion of foreign objects</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">X-rays, CT scans and MRIs</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Fractures and broken bones</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Motor vehicle accidents</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Snake bites</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Heatstroke</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Hyperthyroidism</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Lacerations or abrasion of skin due to external violence</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Bite wound or fight wound abscesses</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Emergency boarding</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Soft tissue injuries</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Lab and diagnostic tests</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Allergic reactions</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Ultrasounds and radiology</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Poisoning</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Blood tests</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Gastrointestinal problems</div>
                </div>
              </td>
            </tr>
            <tr>
              {/* <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Hereditary and congenital issues</div>
                </div>
              </td> */}
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Intervertebral Disc Disease (IVDD)</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Luxating Patella</div>
                </div>
              </td>
            </tr>
            {/* <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Breed specific conditions</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Intervertebral Disc Disease (IVDD)</div>
                </div>
              </td>
            </tr> */}
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Vomiting and diarrhoea</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Arthritis</div>
                </div>
              </td>
            </tr>
            <tr>
              {/* <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Ingestion of foreign objects</div>
                </div>
              </td> */}
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Paw pad injury</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Hip joint surgery</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Embedded grass seeds</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Heart disease</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Tick paralysis</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Anal gland disorders</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Skin Conditions</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Urolithiasis (Urinary stones)</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Ear and eye conditions</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Hyper-adrenocorticism</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Essential euthanasia</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Renal disease</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Gastric dilatation-volvulus (GDV)</div>
                </div>
              </td>
              <td>
                <div className="item">
                  <div className="icon">
                    <Icon
                      className='me-2'
                      src={"/images/icons/check-green-bg.svg"}
                      colorStyle={IconColorStyle.Success}
                      size={IconSize.ExtraSmall}
                    /></div>
                  <div className="content">Vaccinatable diseases – if your pet is up to date with their vaccinations</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {isPet3Age && <>
        <div className="table-content">
          <table className="table table-boxes table-3years">
            <thead>
              <tr>
                <td colSpan={2}>
                  Optional cover available for pets younger than 3 years old
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="item">
                    <div className="icon">
                      <Icon
                        className='me-2'
                        src={"/images/icons/check-green-bg.svg"}
                        colorStyle={IconColorStyle.Success}
                        size={IconSize.ExtraSmall}
                      /></div>
                    <div className="content">Dental illness</div>
                  </div>
                </td>
                <td>
                  <div className="item">
                    <div className="icon">
                      <Icon
                        className='me-2'
                        src={"/images/icons/check-green-bg.svg"}
                        colorStyle={IconColorStyle.Success}
                        size={IconSize.ExtraSmall}
                      /></div>
                    <div className="content">Dental disease, tooth fractures, gingivitis, periodontal disease and more</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="item">
                    <div className="icon">
                      <Icon
                        className='me-2'
                        src={"/images/icons/check-green-bg.svg"}
                        colorStyle={IconColorStyle.Success}
                        size={IconSize.ExtraSmall}
                      /></div>
                    <div className="content">Specialised therapies</div>
                  </div>
                </td>
                <td>
                  <div className="item">
                    <div className="icon">
                      <Icon
                        className='me-2'
                        src={"/images/icons/check-green-bg.svg"}
                        colorStyle={IconColorStyle.Success}
                        size={IconSize.ExtraSmall}
                      /></div>
                    <div className="content">Acupuncture, physiotherapy, hydrotherapy, chiropractic care and more</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="item">
                    <div className="icon">
                      <Icon
                        className='me-2'
                        src={"/images/icons/check-green-bg.svg"}
                        colorStyle={IconColorStyle.Success}
                        size={IconSize.ExtraSmall}
                      /></div>
                    <div className="content">Behavioural therapies</div>
                  </div>
                </td>
                <td>
                  <div className="item">
                    <div className="icon">
                      <Icon
                        className='me-2'
                        src={"/images/icons/check-green-bg.svg"}
                        colorStyle={IconColorStyle.Success}
                        size={IconSize.ExtraSmall}
                      /></div>
                    <div className="content">Anxiety, aggression, obsessive behaviour, destructive chewing and more</div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2}>
                  Plus, so much more
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </>}
      <div className="table-content">
        <div className="note-exclusions">*Exclusions apply. Please see the Product Disclosure Statement for more details</div>
      </div>
    </div>
  );
}
